import(/* webpackMode: "eager", webpackExports: ["ChildrenLayout"] */ "/tmp/seed/source/app/(layouts)/default.client.layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/tmp/seed/source/app/clientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/tmp/seed/source/app/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebPhoneContainer"] */ "/tmp/seed/source/features/webphone/WebPhoneContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/tmp/seed/source/lib/theme.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ColorSchemeScript"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/MantineProvider/ColorSchemeScript/ColorSchemeScript.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Notifications"] */ "/tmp/seed/source/node_modules/@mantine/notifications/esm/Notifications.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-mono\"}],\"variableName\":\"fontMono\"}");
